module.exports = __webpack_public_path__ + "static/media/Vetements-Green-Unicorn-Heel-Sock-Ankle-Boots-Lyst_thumb.03c3fbbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/shoes/Vetements-Green-Unicorn-Heel-Sock-Ankle-Boots-Lyst_thumb.png
// module id = 290
// module chunks = 0